<template>
    <v-autocomplete
        v-model="formData.value"
        :search-input.sync="searchKey"
        :label="title"
        :items="itemSuggestions"
        outlined
        item-text="name"
        item-value="id"
        :disabled="!!readonly"
        :error-messages="formData.value_error || errorMessages"
        :menu-props="{ contentClass: 'select-dense-items' }"
        no-filter
        @focus="backendSearch(false)"
        @input="valueChanged"
    ></v-autocomplete>
</template>

<script>
import { computed, ref, watch } from "@vue/composition-api";
import SupplierModule from "../../store/modules/supplier";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import AppModule from "../../store/modules/app";

export default {
    name: "SupplierField",
    props: {
        accountId: {
            type: Number,
            default: 0
        },
        field: {
            type: Object,
            required: true
        },
        value: {
            type: Number,
            default: null
        },
        valueDisp: {
            type: String,
            default: null
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: ""
        },
        readonly: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const { fetchSuppliers } = SupplierModule();

        const formData = ref({
            value: props.value,
            value_f: props.valueDisp,
            value_error: null
        });
        const searchKey = ref(null);
        const itemSuggestions = ref([]);
        let skipInitialSearch = false;

        const orig_value = computed(function() {
            return props.value;
        });

        const valueChanged = (data) => {
            skipInitialSearch = true;
            formData.value.value_error = null;
            formData.value.value = data;
            ctx.emit("change", formData.value.value);
        };

        const loadData = () => {
            if (props.value) {
                skipInitialSearch = true;
                itemSuggestions.value.push({ id: props.value, name: props.valueDisp });
            }
        };

        const backendSearch = (useSearchKey = true) => {
            let key = useSearchKey ? searchKey.value : '';
            //if (!key)
            //    return;

            setTimeout(() => {
                if (key === searchKey.value || !useSearchKey) {
                    fetchSuppliers(props.accountId, {
                        account_id: props.accountId,
                        sortBy: 'name',
                        sortDesc: false,
                        itemsPerPage: 50,
                        page:1,
                        type_id: parseInt(props.field.type.split(".")[1]),
                        fast_search: 1,
                        keyword: !key ? "" : key
                    })
                        .then(resp => {
                            //if (resp.key !== key)
                            //    return;
                            itemSuggestions.value = resp.items;
                        })
                        .catch(ex => errorDialog.showError(ex));
                }
            }, 250);
        };

        watch(orig_value, function(val) {
            if (formData.value == null) return;
            formData.value.value = val;
            formData.value.value_error = null;
        });


        watch(searchKey, (val, valOld) => {
            if (valOld === undefined && props.value) return;
            if (skipInitialSearch) {
                skipInitialSearch = false;
                return;
            }
            backendSearch();
        });

        loadData();

        return {
            formData,
            searchKey,
            itemSuggestions,
            valueChanged,
            backendSearch
        };
    }
};
</script>
